// Shared helpers + constants for Lead Nurture components
import { Flame, Thermometer, Snowflake } from 'lucide-react';

export const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

// Priority colors and icons
export const PRIORITY_CONFIG = {
  Hot: { color: 'bg-red-500', textColor: 'text-red-600', icon: Flame, bgLight: 'bg-red-50' },
  Warm: { color: 'bg-orange-500', textColor: 'text-orange-600', icon: Thermometer, bgLight: 'bg-orange-50' },
  Cold: { color: 'bg-blue-500', textColor: 'text-blue-600', icon: Snowflake, bgLight: 'bg-blue-50' },
};

// Status colors — pre-qualification CRM stages
export const STATUS_CONFIG = {
  new_lead: { color: 'bg-purple-500', label: 'New Lead' },
  contacted: { color: 'bg-blue-500', label: 'Contacted' },
  discovery: { color: 'bg-cyan-500', label: 'Discovery' },
  educating: { color: 'bg-teal-500', label: 'Educating' },
  pre_qualifying: { color: 'bg-amber-500', label: 'Pre-Qualifying' },
  ready_to_proceed: { color: 'bg-orange-500', label: 'Ready to Proceed' },
  long_term_nurture: { color: 'bg-indigo-500', label: 'Long-term Nurture' },
  converted: { color: 'bg-green-500', label: 'Converted' },
  lost: { color: 'bg-slate-500', label: 'Lost' },
};

// Format relative time
export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return 'Never';
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
};

// Format datetime for display
export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleString('en-AU', {
    weekday: 'short', day: 'numeric', month: 'short',
    hour: 'numeric', minute: '2-digit', hour12: true,
  });
};

// Check if overdue
export const isOverdue = (dateStr) => {
  if (!dateStr) return false;
  return new Date(dateStr) < new Date();
};
